export const CWJ_TASK_ENGINE_VERSION = "0.1.0";
export const DEFAULT_TASK_TIMEOUT_MS = 5 * 60 * 1000; // 5 minutes
export const DEFAULT_TASK_EXPIRY_MS = 24 * 60 * 60 * 1000; // 24 hours
export const CWJ_TASK_PRIORITIES = ["low", "medium", "high", "critical"];
export const CWJ_TASK_STATUSES = [
    "pending",
    "approval_required",
    "running",
    "paused",
    "completed",
    "failed",
    "cancelled",
    "expired",
];
/**
 * Allowed transitions. A missing transition is denied by default.
 * pending -> approval_required models the approval gate.
 * approval_required -> running models owner approval.
 */
export const VALID_CWJ_TASK_TRANSITIONS = [
    { from: "pending", to: "approval_required" },
    { from: "pending", to: "running" },
    { from: "pending", to: "paused" },
    { from: "pending", to: "cancelled" },
    { from: "pending", to: "expired" },
    { from: "approval_required", to: "running", requiresApproval: true },
    { from: "approval_required", to: "paused" },
    { from: "approval_required", to: "cancelled" },
    { from: "approval_required", to: "expired" },
    { from: "running", to: "completed" },
    { from: "running", to: "failed" },
    { from: "running", to: "cancelled" },
    { from: "running", to: "expired" },
    { from: "paused", to: "pending" },
    { from: "paused", to: "approval_required" },
    { from: "paused", to: "cancelled" },
    { from: "paused", to: "expired" },
];
export function isValidCwjTaskTransition(from, to) {
    return VALID_CWJ_TASK_TRANSITIONS.some((t) => t.from === from && t.to === to);
}
export function transitionRequiresApproval(from, to) {
    return VALID_CWJ_TASK_TRANSITIONS.some((t) => t.from === from && t.to === to && t.requiresApproval);
}
export const TERMINAL_CWJ_TASK_STATUSES = [
    "completed",
    "failed",
    "cancelled",
    "expired",
];
export function isTerminalCwjTaskStatus(status) {
    return TERMINAL_CWJ_TASK_STATUSES.includes(status);
}
export const MUTABLE_CWJ_TASK_STATUSES = [
    "pending",
    "approval_required",
    "running",
    "paused",
];
export function isMutableCwjTaskStatus(status) {
    return MUTABLE_CWJ_TASK_STATUSES.includes(status);
}
//# sourceMappingURL=constants.js.map